var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.file.isNew) ? [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('md-input-container', [_c('label', [_vm._v("File Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "autofocus": ""
    },
    model: {
      value: (_vm.file.name),
      callback: function($$v) {
        _vm.file.name = $$v
      },
      expression: "file.name"
    }
  })], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.createFile
    }
  }, [(_vm.createStatus === '') ? _c('md-icon', {
    staticClass: "status-icon md-primary"
  }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), (_vm.createStatus === 'pending') ? _c('md-icon', {
    staticClass: "status-icon md-primary pending"
  }, [_vm._v("refresh")]) : _vm._e(), _vm._v(" "), (_vm.createStatus === 'error') ? _c('md-icon', {
    staticClass: "status-icon md-primary error"
  }, [_vm._v("error")]) : _vm._e()], 1)] : [_c('md-button', {
    staticClass: "md-icon-button md-list-action delete-btn",
    class: {
      error: _vm.deleteStatus === 'error'
    },
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.deleteFile
    }
  }, [(_vm.deleteStatus === 'pending') ? _c('md-icon', {
    staticClass: "status-icon md-primary pending"
  }, [_vm._v("refresh")]) : _c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("delete")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), _c('span', {
    staticClass: "parents"
  }, [_vm._v(_vm._s(_vm.computedParents))])]), _vm._v(" "), (_vm.saveStatus === 'pending') ? _c('md-icon', {
    staticClass: "md-primary status-icon pending"
  }, [_vm._v("refresh")]) : _vm._e(), _vm._v(" "), (_vm.saveStatus === 'success') ? _c('md-icon', {
    staticClass: "md-primary status-icon success"
  }, [_vm._v("cloud_done")]) : _vm._e(), _vm._v(" "), (_vm.saveStatus === 'error') ? _c('md-icon', {
    staticClass: "md-primary status-icon error"
  }, [_vm._v("error")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    staticStyle: {
      "flex": "0"
    },
    on: {
      "click": _vm.triggerEditFile
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("edit")])], 1)]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6bedc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DriveFileListItem.vue
// module id = VUfz
// module chunks = 1